import type { FaireProductEntity } from "../../entity_types/product";

export const p_3bv7oz21rb: FaireProductEntity = {
  token: "p_3bv7oz21rb",
  type: "product",
  name: "Harry Potter Inspired Encouragement Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/8daae0c287004601d3cab57cd204910e9ac0533cf483447430a140c35d733e82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8d2b9b0f4b5d4a5d5f5a5dfee06a7af9d6352403c551913d7fceba5f5132d3f4/1559092570.png",
  ],
  priceDollars: 4.13,
  description:
    "Cast a spell of encouragement with our \"Don't Let The Muggles Get You Down\" Greeting Card! Inspired by the enchanting world of Harry Potter, this card is a magical reminder to stay resilient and brave in the face of adversity. Whether you're sending it to a fellow witch or wizard who needs a boost of confidence or to any brave soul facing life's challenges, this card is sure to charm and inspire. \n\n•Size: A2, 5.5\" x 4.25\"\n•Features: Blank interior and coordinating envelope\n•Sentiment: Don't Let The Muggles Get You Down",
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:00.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
